import { MutableRefObject, useState } from "react";
import styles from "@/adminArea/admin.module.scss";
import { useAnimationFrame } from "framer-motion";

export const AdminAnimationPlayer = ({ modelRef }: { modelRef: MutableRefObject<any> }) => {
	const [currentTime, setCurrentTime] = useState(0);
	useAnimationFrame(() => {
		if (modelRef.current) {
			setCurrentTime(modelRef.current.getTime());
		}
	});
	return (
		<div className={styles.panel}>
			Animation
			{modelRef.current && (
				<>
					<button onClick={() => modelRef.current.playAnimation()}>play</button>
					<button onClick={() => modelRef.current.pauseAnimation()}>pause</button>
					<div className="flex">
						<input className="width-10" type="range" step={0.001} min="0" max={modelRef.current.getDuration()} onChange={(e) => modelRef.current.setTime(parseFloat(e.target.value))} />
						<div className="width-2">{currentTime.toFixed(2)}</div>
					</div>
				</>
			)}
		</div>
	);
};
